export const black = '#1E1C49';
